import React, { useEffect } from "react";

import { PanelWithHeader } from "../panels/PanelWithHeader";

import "./ShoppingList.css";

interface ShoppingListProps {
  header: string;
  rows: any[];
  quickUpdateToShoppingItem: any;
}

export const ShoppingList = (props: ShoppingListProps) => {
  let onCheckedChanged = (id, value) => {
    props.quickUpdateToShoppingItem(id, value);
  };

  return (
    <PanelWithHeader header={props.header} showAddIcon={true}>
      <div className="ShoppingListContainer">
        <div className="list-group list-group-flush">
          {props.rows.map((row, index) => (
            <div className="custom-control custom-checkbox list-group-item d-flex justify-content-between dark-grey-text">
              <input
                type="checkbox"
                defaultChecked={row.completed}
                onChange={(event) => {
                  onCheckedChanged(row.todoId, event.target.checked);
                }}
                className="custom-control-input "
                id={`chkShoppingItem_${row.todoId}`}
              />
              <label
                className="custom-control-label"
                title={row.description}
                htmlFor={`chkShoppingItem_${row.todoId}`}
              >
                {row.name}
              </label>
              <div style={{ color: "darkgray", fontStyle: "italic" }}>
                {row.category}
              </div>
            </div>
          ))}
        </div>
      </div>
    </PanelWithHeader>
  );
};
